import { VersionedTransaction } from '@solana/web3.js';

/** Some signers return only their own signature. Preserve earlier signatures on the identical message. */
export function mergeCreationSignatures(
  original: VersionedTransaction,
  signedBytes: Uint8Array,
): VersionedTransaction {
  const signed = VersionedTransaction.deserialize(signedBytes);
  if (original.version !== 0 || signed.version !== 0)
    throw new Error('Creation requires a version 0 transaction.');
  if (!Buffer.from(original.message.serialize()).equals(Buffer.from(signed.message.serialize())))
    throw new Error('The wallet returned a different transaction. Creation stopped.');
  original.signatures.forEach((signature, index) => {
    if (!signature.some((byte) => byte !== 0)) return;
    const received = signed.signatures[index];
    if (
      received === undefined ||
      (received.some((byte) => byte !== 0) && !Buffer.from(received).equals(Buffer.from(signature)))
    )
      throw new Error('The wallet changed an existing signature. Creation stopped.');
    signed.signatures[index] = Uint8Array.from(signature);
  });
  return signed;
}
